export default __webpack_public_path__ + "img/location-outside.83548716.svg";